import { ActionIcon, Divider, Flex, Stack, Switch } from "@mantine/core";
import { DatePickerInput, DateValue, TimeInput } from "@mantine/dates";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styles from "../NewOrder.module.css";
import { ChangeEvent } from "react";
import { IconArrowLeft } from "@tabler/icons-react";

const PickupDeliveryTime = ({ setShowPickupDelivery }: { setShowPickupDelivery: (show: boolean) => void }) => {
    const { t } = useTranslation(['NewOrder']);
    const { setValue, watch, getValues } = useFormContext();

    const isPickupEnabled = watch('pickup');
    const isDeliveryEnabled = watch('delivery');

    return (
        <Stack className={styles.pickupContent} gap={'xs'}>
            <Flex justify={'space-between'} direction={'column'}>
                <ActionIcon variant='subtle' color='#14a1e6' onClick={() => setShowPickupDelivery(false)}>
                    <IconArrowLeft size={16} />
                </ActionIcon>
                <Divider />
            </Flex>
            <Flex gap={'xs'}>
                <Stack w={'100%'}>
                    <Switch
                        defaultChecked={getValues('pickup')}
                        label={t('FieldName:requiresPickup')}
                        onChange={(value: ChangeEvent<HTMLInputElement>) => {
                            setValue('pickup', value.target.checked);
                            if (!value.target.checked) {
                                setValue('pickupInfo.date', null);
                                setValue('pickupInfo.fromTime', '');
                                setValue('pickupInfo.toTime', '');
                            }
                        }}
                    />
                    <DatePickerInput
                        defaultValue={getValues('pickupInfo.date')}
                        clearable={true}
                        type="default"
                        dropdownType="popover"
                        label={t('FieldName:date')}
                        placeholder={t('FieldName:date')}
                        onChange={(date: DateValue) => setValue('pickupInfo.date', date)}
                        disabled={!isPickupEnabled}
                    />
                    <Flex gap={'md'} w={'100%'}>
                        <TimeInput
                            defaultValue={getValues('pickupInfo.fromTime')}
                            label={t('FieldName:fromTime')}
                            placeholder={t('FieldName:fromTime')}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => setValue('pickupInfo.fromTime', event.target.value)}
                            disabled={!isPickupEnabled}
                        />
                        <TimeInput
                            defaultValue={getValues('pickupInfo.toTime')}
                            label={t('FieldName:toTime')}
                            placeholder={t('FieldName:toTime')}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => setValue('pickupInfo.toTime', event.target.value)}
                            disabled={!isPickupEnabled}
                        />
                    </Flex>
                </Stack>
                <Stack w={'100%'}>
                    <Switch
                        label={t('FieldName:requiresDelivery')}
                        defaultChecked={getValues('delivery')}
                        onChange={(value: ChangeEvent<HTMLInputElement>) => {
                            setValue('delivery', value.target.checked);
                            if (!value.target.checked) {
                                setValue('deliveryInfo.fromTime', '00:00');
                                setValue('deliveryInfo.toTime', '12:00');
                            }
                        }}
                    />
                    <DatePickerInput
                        defaultValue={getValues('deliveryInfo.date')}
                        type="default"
                        dropdownType="popover"
                        label={t('FieldName:date')}
                        placeholder={t('FieldName:date')}
                        onChange={(date: DateValue) => setValue('deliveryInfo.date', date)}
                    />

                    <Flex gap={'md'}>
                        <TimeInput
                            defaultValue={getValues('deliveryInfo.fromTime')}
                            label={t('FieldName:fromTime')}
                            placeholder={t('FieldName:fromTime')}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => setValue('deliveryInfo.fromTime', event.target.value)}
                        />
                        <TimeInput
                            defaultValue={getValues('deliveryInfo.toTime')}
                            label={t('FieldName:toTime')}
                            placeholder={t('FieldName:toTime')}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => setValue('deliveryInfo.toTime', event.target.value)}
                            disabled={!isDeliveryEnabled}
                        />
                    </Flex>
                </Stack>
            </Flex>
        </Stack>
    );
};

export default PickupDeliveryTime;